<div class="button-toggle-container fx-row align-items-center justify-content-start">
  <button *ngFor="let button of buttons; let index = index" class="button-toggle fx-flex" (click)="onClick(index)"
    [class.selected]="button.selected" [class.disabled]="button.disabled" [disabled]="button.disabled"
    [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="(button.tooltip ?? '') | translate"
    [matTooltipDisabled]="!button.tooltip">
    <div class="fx-row align-items-center justify-content-start">
      <mat-icon *ngIf="button.icon" class="mr-5" inline inset>{{button.icon}}</mat-icon>
      <span>{{button.label | translate}}</span>
    </div>
  </button>
</div>
